@if (selectedRoomTopic) {
<div class="col th-p notification-content-wrapper">
  <header class="top-box-shadow studyRoomList">
    <div class="columns is-gapless is-vcentered is-mobile">
      <figure class="has-text-centered">
        <i
          class="hideMobileView fa"
          [ngClass]="{
            'fa-angle-double-left': !this.studyRoomComponent.viewStudyRoomList,
            'fa-angle-double-right': this.studyRoomComponent.viewStudyRoomList
          }"
          (click)="hideShowStudyRoom()"
        ></i>
      </figure>
      @if (!editRoomDetails) {
      <div class="column is-9">
        <h3 class="is-marginless is-clearfix">
          <span
            class="is-size-6 has-text-weight-semibold ellipsis list-active"
            style="max-width: 80%; display: inline-block"
            title="{{ selectedRoomTopic.chat_group_name }}"
            >{{ selectedRoomTopic.chat_group_name }}</span
          >
          <!-- <a class="has-text-info" (click)="editRoomName()">
              <i class="fa fa-pencil fa-font-size pad-7-2"></i>
            </a> -->
          <small class="display-b is-size-7 text-clr-grey">{{
            selectedRoomTopic.createdAt | date : "MMM d, y h:mm a"
          }}</small>
        </h3>
      </div>
      }
      <div class="column is-3">
        <a class="desk-view activeMobileView" (click)="closeActiveUrl()">
          <button type="button" class="button is-link is-outlined is-small">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </a>
      </div>
    </div>
  </header>
  <div class="contents pos-relative">
    <div
      class="notifications scroll-bar"
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="fetchNextTopic()"
    >
      <div class="chat-list mar-0-15">
        <app-studyroom-list
          [studyRoomDataList]="getStudyRoomData"
        ></app-studyroom-list>
      </div>
    </div>
  </div>
</div>
}
